import type { KnowledgeBaseVaultPage } from '@/components/knowledge/types';
import VaultPageDocument from '@/components/knowledge/VaultPageDocument';

interface VaultPagePreviewProps {
  page: KnowledgeBaseVaultPage | null;
  onNavigateInternal: (target: string) => void;
  loading?: boolean;
}

export default function VaultPagePreview({ page, onNavigateInternal, loading = false }: VaultPagePreviewProps) {
  if (!page) {
    return (
      <div className="flex h-full min-h-[28rem] items-center justify-center rounded-2xl border border-dashed bg-card/40 text-sm text-muted-foreground">
        Select a vault page to preview it.
      </div>
    );
  }

  if (loading) {
    return (
      <div className="h-full min-h-[28rem] rounded-2xl border bg-background/80 p-6">
        <div className="space-y-4 rounded-2xl border bg-card p-6 shadow-sm">
          <div className="h-8 w-56 animate-pulse rounded bg-muted" />
          <div className="h-4 w-40 animate-pulse rounded bg-muted" />
          <div className="space-y-3 pt-4">
            <div className="h-4 w-full animate-pulse rounded bg-muted" />
            <div className="h-4 w-[92%] animate-pulse rounded bg-muted" />
            <div className="h-4 w-[88%] animate-pulse rounded bg-muted" />
            <div className="h-4 w-[70%] animate-pulse rounded bg-muted" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="h-full min-h-[28rem] overflow-y-auto rounded-2xl border bg-background/80 p-3"
      style={{ WebkitAppRegion: 'no-drag' } as any}
    >
      <VaultPageDocument markdown={page.content_markdown} onNavigateInternal={onNavigateInternal} />
    </div>
  );
}
